import NodeModule from '../../services/NodeModule';
import Form from './views/Form';
import UserDataFormValidator from './views/UserDataFormValidator';

export default class UserDataNode extends NodeModule {
  start(options) {
    console.log('Starting User Data');
    const userData = new Form({el: options.el, formEl: '#userForm', type: (opts) => new UserDataFormValidator(opts)});
  }
}